<template>
  <div class="list-page">
    <crumbs title="政策通知审核" />
    <div class="list-page__querybar">
      <el-row>
        <el-col :span="6">
          <enumerate
            url="/api/achievement/getimauditstatus"
            v-model="queryCondition.auditStatus"
            placeholder="审核状态"
          />
        </el-col>
        <el-col :span="6">
          <el-date-picker
            v-model="queryCondition.publishDate"
            type="daterange"
            :unlink-panels="true"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd"
            style="width: 100%"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="10">
          <el-input
            v-model="queryCondition.keyWord"
            clearable
            placeholder="搜索标题"
          >
          </el-input>
        </el-col>
        <el-col class="fn-text-right" :span="2">
          <el-button
            @click="handleSearch"
            size="medium"
            type="success"
            icon="el-icon-search"
            round
            >查询</el-button
          >
        </el-col>
      </el-row>
    </div>
    <div class="list-page__toolbar"></div>
    <div
      class="list-page__table"
      v-loading="isLoading"
      element-loading-text="拼命加载中"
    >
      <el-table
        :data="queryList"
        border
        tooltip-effect="dark"
        style="width: 100%"
      >
        <!-- @selection-change="handleSelectionChange" -->
        <!-- <el-table-column type="selection" width="40"> </el-table-column> -->
        <el-table-column prop="name" label="标题" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="source" label="发布来源" show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="directionName"
          label="主题"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column label="创建时间" width="90" align="center">
          <template slot-scope="scope">
            <p>
              {{ scope.row.createTime.trim().split(/\s+/)[0] }}
            </p>
            <!-- <p>
                {{ scope.row.createTime.trim().split(/\s+/)[1] }}
              </p> -->
          </template>
        </el-table-column>
        <el-table-column
          prop="auditStatusName"
          label="审核状态"
          width="100"
          align="center"
        >
        </el-table-column>
        <el-table-column label="操作" width="120" align="center">
          <template slot-scope="scope">
            <template v-if="scope.row.auditStatus === 0">
              <el-button
                size="mini"
                type="primary"
                @click="handleAudit(scope.row)"
                >审核</el-button
              >
            </template>
            <template v-else-if="scope.row.auditStatus === 1"
              >审核通过</template
            >
            <template v-else>
              <el-button
                size="mini"
                type="primary"
                @click="handleAudit(scope.row)"
                >重新编辑</el-button
              >
            </template>
          </template>
        </el-table-column>
      </el-table>
      <div class="fn-text-center mt-20">
        <el-pagination
          background
          layout="total, prev, pager, next, jumper"
          :hide-on-single-page="true"
          :total="total"
          :page-size="queryCondition.pageSize"
          :current-page.sync="queryCondition.pageIndex"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "policyMessageAudit",
  data() {
    return {
      //查询条件
      queryCondition: {
        auditStatus: "",
        publishDate: [],
        keyWord: "",
        pageIndex: 1,
        pageSize: 15
      },
      total: 0,
      //是否处于loading状态
      isLoading: true,
      //查询结果
      queryList: [],
      //表格当前的选项（多选）
      multipleSelection: []
    };
  },
  created() {
    this.createQueryCondition();
    this.loadList();
  },
  methods: {
    //出来参数
    processParams() {
      let { keyWord, pageIndex, pageSize, publishDate } = this.queryCondition,
        mixin = {
          auditStatus: ""
        },
        [createBegin = "", createEnd = ""] = publishDate || [];

      Object.keys(mixin).map((item) => {
        mixin[item] =
          this.queryCondition[item] === "" ? -1 : this.queryCondition[item];
      });
      return {
        keyWord,
        pageIndex,
        pageSize,
        ...mixin,
        createBegin,
        createEnd
      };
    },
    //获取列表
    loadList() {
      //初始化
      // this.queryList = [];
      this.isLoading = true;
      this.$api("policy", "getMessageAuditList", this.processParams()).then(
        (res) => {
          this.isLoading = false;
          this.total = res.count;
          this.queryList = res.dataList;
        }
      );
    },
    //点击后查询
    handleSearch() {
      this.queryCondition.pageIndex = 1;
      this.loadList();
    },
    // //表格相关
    // //点击选中/取消选中表格选择项
    // handleSelectionChange(selection) {
    //   this.multipleSelection = selection;
    // },
    //点击审核
    handleAudit(row) {
      const { id } = row;
      this.redirectByPath(
        `/admin/policyManage/policyMessageInfo/audit`,
        {
          id
        },
        this.queryCondition
      );
    },
    //点击切换分页触发
    handleCurrentChange() {
      this.loadList();
    }
  }
};
</script>

<style></style>
